export const stringHelper = {
    /**
     * differences with padStart:
     * 'abc'.padStart(10, "foo") -> "foofoofabc"
     * stringHelper.padStartWithStrAsChar('abc', 10, 'foo') -> foofoofoofoofoofoofooabc
     */
    padStartWithStrAsChar: (text, minLength) => {
        let formattedText = '' + text;
        let needSpaces = minLength - formattedText.length;

        while (needSpaces > 0) {
            formattedText = '\u2006 ' + formattedText;
            needSpaces--;
        }

        return formattedText;
    },

    cropToChar(string, char) {
        const charPosition = string.indexOf(char);
        return charPosition !== -1 ? string.slice(0, charPosition) : string;
    },

    stringToBool: (str) => {
        if (typeof str === 'string') {
            str = str.toLowerCase();
            if (str === 'false') {
                return false;
            } else if (str === 'true') {
                return true;
            }
            console.error('got unknown string as bool:', str);
            return !!str;
        }
        return !!str;
    },

    upperFirstLetter(str) {
        return str[0].toUpperCase() + str.slice(1);
    },
};
